export enum ImportTypeEnum {
  ADDRESS_BOOK,
  SHIPMENT
}



// WEBPACK FOOTER //
// ./src/app/model/importType.enum.ts